$(function(){
	setupPill();
});

function setupPill(){
	$('.pill').each(function(){
		var t = $(this);
		if(t.data('group')) t.group = t.data('group'); else t.group = 0;
		t.addClass('pillgroup-' + t.group);
		t.click(function(){
			$('.pillgroup-' + t.group).removeClass('selected');
			t.addClass('selected');
		});
	});
} 